/* eslint-disable */

import * as d3 from "d3"
import { CrainD3Vis } from "./CrainD3Vis.js"
import { escapeHtml, getColorScale } from './utilities'

class WorldMapControl extends CrainD3Vis {
    constructor(svg, cd, svgDiv) {
        super(svg, cd, svgDiv);
        this.selectClass = 'datacountry';
        this.layout = {
            width: this.svgDiv ? document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetWidth : undefined,
            height: this.svgDiv ? document.getElementById(this.svgDiv.split(" ")[0].slice(1)).offsetHeight : undefined,
            projection: undefined,
            responsive: document.getElementById(this.svgDiv.split(" ")[0].slice(1)).getAttribute("layout")
        };
        this.config = {
            normalGraphWidth: 800,
            normalGraphHeight: 400,
            color: "Size"
        };
        this.worldMap = undefined;
        this.dataIndex = undefined;
        this.scale = undefined;
        this.interpolator = undefined;
        this.dataLabel = undefined;
        this.dataLoc = undefined;
        this.controlNormalFormatting = this.controlNormalFormatting.bind(this);
        this.controlSelectFormatting = this.controlSelectFormatting.bind(this);
    }

    /**
     * performs formatting in normal modus
     * @param selection
     */
    controlNormalFormatting(selection) {
        selection.select('path')
            .attr('fill', d => { return d.data ? this.interpolator(this.scale(d[this.dataLoc][this.dataLabel])) : 'gray' })
            .attr('stroke-width', this.layout.width / 1000)
            .attr('stroke', '#ddded9')
    }


    /**
     * Perform formatting when in selection modus
     * @param selection: d3 selection of groups contraining rects
     */
    controlSelectFormatting(selection) {
        if (this.crainData.selected.size > 0) {
            selection.select('path').attr('fill', d => d.selected ? this.interpolator(this.scale(d[this.dataLoc][this.dataLabel])) : (d.data ? 'lightgray' : 'gray'))

        } else {
            selection.call(this.controlNormalFormatting)
        }

    }

    layoutCalculations() {
        this.responsive = this.layout.responsive;
        if (this.layout.width && this.layout.height && this.responsive) {
            //this.layout.width = this.svg.attr('width');
            //this.layout.height = this.svg.attr('height');
            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        } else {
            this.layout.width = this.config.normalGraphWidth;
            this.layout.height = this.config.normalGraphHeight;
            this.svg.attr('width', this.layout.width);
            this.svg.attr('height', this.layout.height);
        }
        this.projection = d3.geoMercator().fitSize([this.layout.width, this.layout.height], this.worldMap)
    }

    createDataIndex() {
        this.dataIndex = {};
        this.crainData.processedData.forEach((d, c) => {
            this.dataIndex[this.crainData.xLayers[d.x][0].name] = d;
        });
        this.worldMap.features.forEach(d => {
            let r = this.getData(d);
            if (r) {
                d.data = r.data;
                d.filtdata = r.filtdata;
                d.fingerprint = r.fingerprint;
            } else {
                // Remove data from feature if nothing is found anymore
                delete d.data;
                delete d.filtdata;
                delete d.fingerprint;
            }
        });
    }

    /**
     * Matches data from geojson with info in dataindex
     * @param d: datapoint from geojson
     * @returns {*}
     */
    getData(d) {
        let key = Object.entries(d.properties).find(x => { return x[1] in this.dataIndex });
        if (key) {
            return this.dataIndex[key[1]]
        }
    }

    setScale() {
        if (this.config.color === "recency") {
            let { scale, interpolator, dataLabel } = getColorScale("recency_linear", this.crainData.processedData);
            this.scale = scale;
            this.interpolator = interpolator;
            this.dataLabel = dataLabel
        } else if (this.config.color === "size") {
            let { scale, interpolator, dataLabel } = getColorScale("size_log", this.crainData.processedData);
            this.scale = scale;
            this.interpolator = interpolator;
            this.dataLabel = dataLabel
        } else if (this.config.color === "origsize") {
            let { scale, interpolator, dataLabel } = getColorScale("size_log", this.crainData.processedData);
            this.scale = scale;
            this.interpolator = interpolator;
            this.dataLabel = dataLabel
        }
        let colorScale;
        if (["recency", "relrecency", "relsize", "linked", "filtrecency"].includes(this.config.color)) {
            colorScale = getColorScale(this.config.color + "_linear", this.crainData.processedData);
        } else if (["size", "origsize", "filtsize"].includes(this.config.color)) {
            colorScale = getColorScale(this.config.color + "_log", this.crainData.processedData);
        }
        this.scale = colorScale.scale;
        this.interpolator = colorScale.interpolator;
        this.dataLabel = colorScale.dataLabel;

        if (["recency", "size", "origsize"].includes(this.config.color)) {
            this.dataLoc = "data"
        } else {
            this.dataLoc = "filtdata"
        }
    }


    /**
     * Draw worldmap
     * @param g g#main
     */
    drawMap(g) {
        let svgDiv = this.svgDiv;
        let paths = g.selectAll("g." + this.selectClass).data(this.worldMap.features, d => d.id);
        paths.exit().remove();
        let newPaths = paths.enter()
            .append('g')
            .attr('class', this.selectClass);

        let cd = this.crainData;
        newPaths.append("path")
            .attr('d', d3.geoPath().projection(this.projection))
            .on('mouseover', function(d) {
                if (d.data) {
                    d3.select(this).attr('opacity', 0.4)
                    d3.select('#hoverDiv')
                        .style('opacity', 0.9)
                        .style('top', event.clientY + 10 + 'px')
                        .style('left', event.clientX + 10 + 'px')
                        .html(`
                            <strong>${escapeHtml(d.properties.NAME)}</strong><br>
                            Period: ${cd.rawData.meta.startyear}-${cd.rawData.meta.recentyear}-${cd.rawData.meta.stopyear}<br>
                            <br>
                            Size: ${d.filtdata? d.filtdata.size:d.data.origsize}<br>
                            Recency: ${d.filtdata? d.filtdata.recency:d.data.recency}<br>
                            Origsize: ${d.data.origsize} (${cd.rawData.meta.poolstart}-${cd.rawData.meta.poolstop})
                        `)
                };
            })
            .on('mouseout', function(d) {
                if (d.data) {
                    d3.select(this).attr('opacity', 1)
                    d3.select('#hoverDiv')
                        .style('opacity', 0);
                }
            });

        newPaths.merge(paths).call(this.controlDataPointFormatting)

    }

    /**
     * Download worldmap if it doesnt exist
     * @returns {Promise<void>}
     */
    async downloadMap() {
        if (!this.worldMap) {
            await d3.json('/data/worldmap/world.geojson').then(x => { this.worldMap = x });
        };
    }


    async update(reset = false) {
        await this.downloadMap();
        this.createDataIndex(); // Data is appended/changed to current selected data. Needs to be done every time (or only if z-changes)
        this.layoutCalculations();
        this.setScale();
        if (reset) {
            this.svg.select('g#main').remove();
        }

        let g = this.svg.select('g#main');
        let zoomrect = g.select('#zoomrect');
        if (g.empty()) {
            g = this.svg.append('g').attr('id', 'main');
            zoomrect = g.append('rect').attr('id', 'zoomrect')
                .attr('width', this.svg.attr('width'))
                .attr('height', this.svg.attr('height'))
                .attr('opacity', 0);
        };

        g.call(d3.zoom().on("zoom", () => {
            g.attr("transform", d3.event.transform)
        }));
        this.drawMap(g);
        this.controlSelect();
        document.getElementById("load-div-worldmap")? document.getElementById("load-div-worldmap").classList.remove("show"): console.log();
    }
}

export { WorldMapControl }
